import { render, staticRenderFns } from "./ListSelectedVisitPointsItemPickup.vue?vue&type=template&id=52c54fba&scoped=true"
import script from "./ListSelectedVisitPointsItemPickup.vue?vue&type=script&lang=js"
export * from "./ListSelectedVisitPointsItemPickup.vue?vue&type=script&lang=js"
import style0 from "./ListSelectedVisitPointsItemPickup.vue?vue&type=style&index=0&id=52c54fba&prod&lang=scss&scoped=true"
import style1 from "./ListSelectedVisitPointsItemPickup.vue?vue&type=style&index=1&id=52c54fba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c54fba",
  null
  
)

export default component.exports